import { useEffect, useState } from "react";

import Metadata from "./Metadata";
import { getStorageItem, setStorageItem } from "./utils/common-utils";
import { FALLBACK_IP_INFO } from "./utils/constants";
import { connect } from "./web-socket";

/**
 * App bootstrap.
 *
 * This used to block the entire app on `GET /apps/init`, which returned the
 * base URL, api key and socket URL to cache in localStorage. The Sayagie
 * backend has no such endpoint (404), and because the old code only set
 * `initialized` inside the success handler, a failure left the app on the
 * loader forever. Configuration is static now — see `lib/api/env.js` — so
 * there is nothing to wait for.
 */
const Init = () => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    // `/ip-info` is also gone. Seed the default so the phone input and the
    // map have a country and a centre before geolocation is granted.
    if (!getStorageItem("ip-info")) {
      setStorageItem("ip-info", FALLBACK_IP_INFO);
    }

    connect();
    setInitialized(true);
  }, []);

  if (!initialized) return null;

  return <Metadata />;
};

export default Init;
